var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-layout"},[_vm._t("dialog"),_vm._l((_vm.$slots.default),function(node,index){return _c('zy-column-render',{key:index,attrs:{"node":node,"width":_vm.columns[index]}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }